import { render } from "./FlowyNavMenuItem.vue?vue&type=template&id=14079939"
import script from "./FlowyNavMenuItem.vue?vue&type=script&lang=js"
export * from "./FlowyNavMenuItem.vue?vue&type=script&lang=js"

import "./FlowyNavMenuItem.vue?vue&type=style&index=0&id=14079939&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__